module.exports = __webpack_public_path__ + "img/49.10.pH.613d7a65.png";